<button
  class="chipActionDs__{{type}}__button chipActionDs__{{type}}__button--{{chipStatus}} branding-{{chipActionBranding}}"
  aria-label="chipActionDs"
  [class.loading]="isLoading"
  [disabled]="isDisabled"
  (click)="clickTrigger()">
  <span
    class="chip chip--{{chipStatus}} chip--{{size}} branding-{{chipActionBranding}}"
    [ngStyle]="{
      height: height,
      width: width
    }">
    <ng-container *ngIf="!isLoading; else loader">
      <div class="chip-icon chip-icon--{{chipActionBranding}}" *ngIf="icon">
        <app-ds-icon
          [icon]="icon"
          [size]="iconSize">
        </app-ds-icon>
      </div>
    </ng-container>
    <ng-container *ngIf="isValidBranding">
      <div
        class="chipActionDs__branding-banner--{{chipActionBranding}} chipActionDs__branding-banner--{{chipActionBranding}}-{{type}}"
        [class.disabled]="isDisabled">
        <app-ds-icon
          [icon]="iconBranding"
          [size]="iconBrandingSize">
        </app-ds-icon>
      </div>
    </ng-container>
  </span>
  <ng-container *ngIf="showLabel">
    <app-ds-typography
      class="chipActionDs__{{type}}__label"
      [fontFamily]="fontFamily"
      [size]="fontSize"
      [text]="label">
    </app-ds-typography>
  </ng-container>
</button>

<ng-template #loader>
  <app-ds-loader-ring
    [size]="loaderSize"
    [type]="loaderRingType">
  </app-ds-loader-ring>
</ng-template>
